<template>
  <div class="dropdown-center">
    <button
      id="dropdowFlexDriveFilterTransmission"
      class="form-select form-select-short"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false">
      <div v-if="selected.length" class="form-select-wrapper">
        <div>
          <span v-if="selected.length === 1">
            {{ getOptionText(selected[0]) }}
          </span>
          <span v-else>
            {{ selected.length }}
            {{ dictionary.transmissionsSelectedSuffix }}
          </span>
        </div>
        <button
          type="button"
          class="btn btn-clear btn-reset"
          title="Clear"
          @click.stop="resetSelected">
          <i class="icon-close"></i>
        </button>
      </div>
      <div v-else>{{ dictionary.transmissionsPlaceholder }}</div>
    </button>
    <div
      class="dropdown-menu"
      aria-labelledby="dropdowFlexDriveFilterTransmission">
      <div class="b-fleet-filters" @click.stop>
        <div class="b-fleet-filters__body">
          <ul>
            <li v-for="item in options" :key="item.value">
              <input
                :id="item.value"
                v-model="selected"
                class="form-check-input"
                autocomplete="off"
                type="checkbox"
                :value="item.value"
                :disabled="item.disabled"
                @change="onChange" />
              <label class="form-check-label" :for="item.value" @click.stop>
                {{ item.text }} ({{ getOptionCount(item.value) }})
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { compact, uniqBy } from 'lodash'
import mixinsFlexDrive from './../../mixins/flexdrive-mixins'

export default {
  mixins: [mixinsFlexDrive],
  props: {
    records: {
      required: true,
      type: Array,
    },
  },
  emits: ['change-selected'],
  data() {
    return {
      selected: [],
    }
  },
  computed: {
    options() {
      const array = this.records.map((x) => ({
        value: x.transmissionTypePreValue,
        text: x.transmissionType,
        selected: false,
        disabled: this.isDisabled(x.transmissionTypePreValue),
      }))

      /* eslint-disable no-undef */
      return _.uniqBy(array, 'value')
    },
  },
  mounted() {
    this.selected = this.transmissions
  },
  methods: {
    getOptionCount(value) {
      const data = this.getData()
      return data.filter((i) => i.transmissionTypePreValue === value).length
    },

    isDisabled(value) {
      const data = this.getData()
      const exists = data.some((i) => i.transmissionTypePreValue === value)
      return !exists
    },

    getData() {
      let array = this.records

      if (this.brands.length) {
        array = array.filter((i) => this.brands.includes(i.make))
      }

      if (this.models.length) {
        array = array.filter((i) => this.models.includes(i.model))
      }

      if (this.fuels.length) {
        array = array.filter((i) => this.fuels.includes(i.fuelPreValue))
      }

      if (this.prices.length) {
        array = array.filter(
          (i) =>
            i.pricePerMonthInteger >= this.prices[0] &&
            i.pricePerMonthInteger <= this.prices[1]
        )
      }

      return array
    },

    getOptionText(value) {
      return this.options.find((i) => i.value === value).text
    },

    resetSelected() {
      this.selected = []
      this.onChange()
    },

    onChange() {
      this.$emit('change-selected', this.selected)
    },
  },
}
</script>
